// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1C_0c","validationTips":"StatementDescriptor_validationTips__2RxWo"};